import MenuPageItem from "./MenuPageItem";

export default function MenuPageItemSave({ formUtility, onClick }) {

    function handleOnClick(e) {
        if (!onClick || formUtility?.fieldsDisabled)
            return;

        formUtility?.setSaveInProgress(true);

        onClick().finally(() => formUtility?.setSaveInProgress(false));
    }

    return (
        <>
            {
                onClick && (!formUtility || (formUtility.data && formUtility.hasChanges))
                    ? <MenuPageItem iconClassName={formUtility?.saveInProgress ? "fa fa-spinner fa-pulse" : "fas fa-save"} text="SAVE" onClick={handleOnClick} />
                    : null
            }
        </>
    );
}